import { filter as _filter } from 'lodash';

class BrandModelManagementController {
  constructor(authService, loadingService, brandModelService) {
    "ngInject";

    if(!authService.authData.isAdmin) { return; }

    this.loadingService = loadingService;
    this.brandModelService = brandModelService;

    this.filterParams = {};

    this.reset();
  }

  reset() {
    const ctrl = this;

    this.filterParams.brandName = null;
    this.filterParams.brandModelName = null;

    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 50
    };

    this.filterParams.pageCriteria = {
      pageStart: 0,
      itemsToFetch: this.pagination.pageSize,
      sortExpression: 'brandName',
      ascending: true
    };

    this.notification = {
      type: 'info',
      msg: ''
    };

    this.viewBrandModels();
  }

  updatePageIndex() {
    if (this.pagination.currentPage === 1) {
      this.filterParams.pageCriteria.pageStart = 0;
    }
    else {
      this.filterParams.pageCriteria.pageStart = ((this.pagination.currentPage-1) * this.pagination.pageSize);
    }
  }

  updateSort(fieldName) {
    if (this.filterParams.pageCriteria.sortExpression === fieldName) {
      this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
    }
    else {
      this.filterParams.pageCriteria.sortExpression = fieldName;
      this.filterParams.pageCriteria.ascending = true;
    }

    this.viewBrandModels();
  }

  viewBrandModels() {
    const ctrl = this;

    ctrl.updatePageIndex();

    ctrl.loadingService.showLoading('brandModelList', 'Loading Brand Models ...');

    ctrl.brandModelService.listBrandModels(ctrl.filterParams)
      .then(response => {
        ctrl.brandModels = response.data.items;
        ctrl.pagination.totalItems = response.data.totalRecords;

        if (ctrl.pagination.totalItems === 0) {
          ctrl.notification = {
            type: 'info',
            msg: `No data to display`
          }
        }
        else {
          const pageEnd = (ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize) < response.data.totalRecords ? (ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize) :  response.data.totalRecords;

          ctrl.notification = {
            type: 'info',
            msg: `Currently display ${(ctrl.filterParams.pageCriteria.pageStart+1)} to ${pageEnd} out of ${ctrl.pagination.totalItems} vehicles`
          }
        }
      })
      .catch(err => {

      })
      .finally(() => {
        ctrl.loadingService.hideLoading('brandModelList');
      })
  }

}

export default BrandModelManagementController;


// WEBPACK FOOTER //
// ./client/app/components/admin/brandModelManagement/brandModelManagement.controller.js